export default class EMStandardPoint {
    constructor(arg) {
        if (arg != undefined) {
            this.des = arg.des === undefined ? "" : arg.des;
            this.id_tabella = arg.id_tabella === undefined ? -1 : arg.id_tabella;
            this.tipo = arg.tipo === undefined ? "MAN_STRUTTURA_DEFAULT" : arg.tipo;
            this.validita = arg.validita === undefined ? 1 : arg.validita;
        } else {
            this.des = "";
            this.id_tabella = -1;
            this.tipo = 'MAN_STRUTTURA_DEFAULT';
            this.validita = 1;
        }
    }
}